import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import ServiceListStore from '../stores/ServiceList';
import { useStore } from '../hooks/useStore';
import { autoCreateStarterServices } from '../actions/ServiceList';
import { Fetching } from './Fetching';
import SuggestedServicesErrorScreen from './SuggestedServicesErrorScreen';

// AB treatment arm: on mount fires the backend auto-create once, showing a loader then an error/reload screen.
const AutoSaveStarterServices = ({ staticContent }) => {
  const { isAutoCreatingStarterServices, autoCreateStarterError } = useStore(ServiceListStore);

  const hasTriggered = useRef(false);

  useEffect(() => {
    if (hasTriggered.current) return () => {};
    hasTriggered.current = true;

    // Defer to a fresh task so we don't dispatch mid-dispatch when the zero state mounts inside a Flux dispatch.
    const timerId = setTimeout(() => autoCreateStarterServices(), 0);

    return () => clearTimeout(timerId);
  }, []);

  if (autoCreateStarterError) {
    return (
      <SuggestedServicesErrorScreen
        staticContent={ staticContent }
        onReload={ autoCreateStarterServices }
      />
    );
  }

  if (isAutoCreatingStarterServices) {
    return <Fetching fetching />;
  }

  return null;
};

AutoSaveStarterServices.propTypes = {
  widgetId: PropTypes.string,
  staticContent: PropTypes.object,
  router: PropTypes.object
};

export default AutoSaveStarterServices;
